import React from "react";
import Portfolio from "../components/portfolio";

const PortfolioPage = () => {
  return (
    <>
      <div id="overlay-container" />
      <Portfolio />
    </>
  );
};

export default PortfolioPage;
